"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-venerina": {
    "ffcebe7e": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "belfiore": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b8cffed": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "carminello": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c179c3bd": [{
      "hkey": "04497fe6",
      "slug": "linera-cosentini-maria-vergine",
      "name": "Linera-Cosentini-Maria Vergine",
      "primary": true,
      "skipSearch": false
    }],
    "cosentini": [{
      "hkey": "04497fe6",
      "slug": "linera-cosentini-maria-vergine",
      "name": "Linera-Cosentini-Maria Vergine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santa-venerina"
    }],
    "f42b8b5e": [{
      "hkey": "0fb034e8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "dagala-del-re": [{
      "hkey": "0fb034e8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "31d1fec4": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "fontana": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "31a307f1": [{
      "hkey": "04497fe6",
      "slug": "linera-cosentini-maria-vergine",
      "name": "Linera-Cosentini-Maria Vergine",
      "primary": true,
      "skipSearch": false
    }],
    "linera": [{
      "hkey": "04497fe6",
      "slug": "linera-cosentini-maria-vergine",
      "name": "Linera-Cosentini-Maria Vergine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "399cb5bd": [{
      "hkey": "04497fe6",
      "slug": "linera-cosentini-maria-vergine",
      "name": "Linera-Cosentini-Maria Vergine",
      "primary": true,
      "skipSearch": false
    }],
    "maria-vergine": [{
      "hkey": "04497fe6",
      "slug": "linera-cosentini-maria-vergine",
      "name": "Linera-Cosentini-Maria Vergine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santa-venerina"
    }],
    "8e28c92a": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "maugeri": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa43de08": [{
      "hkey": "0fb034e8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "monacella": [{
      "hkey": "0fb034e8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e7a34851": [{
      "hkey": "0fb034e8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "3afeda82": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "morgioni": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62270a5c": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "nizzeti": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fba548e7": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "portiere-crocifisso": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4f197cff": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "skipSearch": false
    }],
    "seminara": [{
      "hkey": "39f69492",
      "slug": "santa-venerina",
      "name": "Santa Venerina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "centro-dagala-del-re": [{
      "hkey": "0fb034e8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;